export default async function getMenuData() {
  return [
    {
      category: true,
      title: 'Eternal Investment',
    },
    {
      title: 'Dashboard',
      key: 'dashboards',
      icon: 'fe fe-home',
      url: '/dashboard',
      // roles: ['admin'], // set user roles with access to this route
    },
    {
      category: true,
      title: 'Apps & Pages',
    },

    {
      title: 'DaroodoSalam',
      key: 'daroodoSalam',
      url: '/DaroodoSalam',
      icon: 'fa fa-calculator',
      children: [
        {
          title: 'Submit DaroodoSalam',
          key: 'submitDaroodosalam',
          url: '/Submit-Daroodosalam',
        },
        {
          title: 'Halqa-e-DaroodoSalam',
          key: 'halqaDaroodoSalam',
          url: '/Halqa-e-Daroodosalam',
        },
        {
          title: 'My DaroodoSalam',
          key: 'myDaroodoSalam',
          url: '/My-Daroodosalam',
        },
      ],
    },
    {
      title: 'Halqa',
      key: 'halqa',
      url: '/Halqa',
      icon: 'fa fa-users',
      children: [
        {
          title: 'Joined Halqa',
          key: 'joinedHalqa',
          url: '/Joined-Halqa',
          icon: 'fa fa-user-circle-o',
        },
        {
          title: 'My Halqa',
          key: 'myHalqa',
          url: '/My-Halqa',
          icon: 'fa fa-circle-o',
        },
        {
          title: 'Create New Halqa',
          key: 'createNewHalqa',
          url: '/Create-New-Halqa',
          icon: 'fa  fa-handshake-o',
        },
      ],
    },
    {
      title: 'Calendar',
      key: 'calendar',
      url: '/Calendar',
      icon: 'fa fa-calendar',
      children: [
        {
          title: 'Hijri Calendar',
          key: 'hijriCalendar',
          url: '/Hijri-Calendar',
        },
        {
          title: 'Gregorian Calendar',
          key: 'gregorianCalendar',
          url: '/Gregorian-Calendar',
        },
      ],
    },
    {
      title: 'Maps',
      key: 'maps',
      icon: 'fa fa-globe',
      children: [
        {
          title: 'My Country Map',
          key: 'myCountryMap',
          url: '/My-Country-Map',
          icon: 'fa fa-map-o',
        },
        {
          title: 'My City Map',
          key: 'myCityMap',
          url: '/My-City-Map',
          icon: 'fa fa-map',
        },
        {
          title: 'Near Location Map',
          key: 'nearLocationMap',
          url: '/Near-Location-Map',
          icon: 'fa fa-street-view',
        },
        {
          title: 'Search Location Map',
          key: 'searchLocationMap',
          url: '/Search-Location-Map',
          icon: 'fa fa-map-marker',
        },
      ],
    },
    {
      title: 'Flags',
      key: 'flags',
      url: '/Flags',
      icon: 'lnr lnr-flag',
      children: [
        {
          title: 'My Flag',
          key: 'myFlag',
          url: '/My-Flag',
          icon: 'fa fa-flag',
        },
      ],
    },
    {
      title: 'Graphs',
      key: 'graphs',
      url: 'pages/Graphs',
      icon: 'fa fa-bar-chart',
      children: [
        {
          title: 'Line Graph',
          key: 'lineGraph',
          url: '/Line-Graph',
          icon: 'fa fa-line-chart',
        },
        {
          title: 'Pie Graph',
          key: 'pieGraph',
          url: '/Pie-Graph',
          icon: 'fa fa-pie-chart',
        },
        {
          title: 'Bar Graph',
          key: 'barGraph',
          url: '/Bar-Graph',
          icon: 'fa fa-bar-chart',
        },
        {
          title: 'Chart Graph',
          key: 'chartGraph',
          url: '/Chart-Graph',
          icon: 'fa fa-area-chart',
        },
      ],
    },
    {
      title: 'Prayers Time',
      key: 'prayersTime',
      icon: 'fa  fa-clock-o',
      children: [
        {
          title: 'Prayers Time',
          key: 'prayersTime',
          url: '/Prayers-Time',
        },
        {
          title: 'Prayers Alert',
          key: 'prayersAlert',
          url: '/Prayers-Alert',
        },
      ],
    },
    {
      title: 'Qibla Direction',
      key: 'qiblaDirection',
      url: '/Qibla-Direction',
      icon: 'fa fa-compass',
    },
    {
      title: 'Near Mosque',
      key: 'nearMosque',
      url: '/Near-Mosque',
      icon: 'fa fa-moon-o',
    },
    {
      title: 'Wazaif',
      key: 'wazaif',
      url: '/Wazaif',
      icon: 'lnr lnr-book',
      children: [
        {
          title: 'My Wazaif',
          key: 'myWazaif',
          url: '/My-Wazaif',
        },
        {
          title: 'Add New Wazaif',
          key: 'addNewWazaif',
          url: '/Add-New-Wazaif',
        },
      ],
    },
    {
      title: 'Profile',
      key: 'profile',
      url: '/Profile',
      icon: 'fa fa-user',
      children: [
        {
          title: 'My Stats',
          key: 'myStats',
          url: '/My-Stats',
        },
        {
          title: 'Edit Profile',
          key: 'editProfile',
          url: '/Edit-Profile',
        },
        {
          title: 'Logout',
          key: 'logout',
          url: '/Logout',
        },
      ],
    },
  ]
}
